import React from "react";
import { createRoot } from "react-dom/client";
import { ACM } from "./ACM";

const domNode = document.getElementById("root");
const root = createRoot(domNode);
root.render(<ACM />);
